<ng-content></ng-content>
@if (isFooter) {
  <footer>
    <div>
      <a
        class="terms-policy-link"
        aria-label="Open Terms of Use in a new window"
        i18n-aria-label
        target="_blank"
        [href]="policyDomain + 'terms'"
        rel="noopener noreferrer"
        >{{ LABEL_CONSTANT.TERMS_OF_USE }}</a
      >
    </div>
    @if (showPrivacyPolicy) {
      <a
        class="terms-policy-link"
        target="_blank"
        aria-label="Open Privacy Policy in a new window"
        i18n-aria-label
        [href]="policyDomain + 'privacy'"
        rel="noopener noreferrer"
        >{{ LABEL_CONSTANT.PRIVACY_POLICY }}</a
      >
    }
  </footer>
}
